// Client for the internalApi Express app (global-admin only, requireAdmin - no manager context).
import {Auth} from "./firebase";

export async function internalApi(path, body = {}, method = "POST") {
    const currentUser = Auth.currentUser;

    if (!currentUser) {
        throw new Error("notLoggedIn");
    }

    const callerToken = await currentUser.getIdToken();

    const baseUrl = `${process.env.REACT_APP_INTERNAL_API_URL}${path}`;

    // GET requests can't carry a body, so send the same fields as query params instead.
    const url = method === "GET"
        ? `${baseUrl}?${new URLSearchParams(
            Object.entries(body).map(([key, value]) => [key, String(value)]),
        ).toString()}`
        : baseUrl;

    const response = await fetch(url, {
        method,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${callerToken}`,
        },
        body: method === "GET" ? undefined : JSON.stringify(body),
    });

    let data;

    try {
        data = await response.json();
    } catch (error) {
        if (!response.ok) {
            const message = response.status === 404
                ? "Internal API route not found (404)"
                : `Internal API returned HTTP ${response.status}`;

            const apiError = new Error(message);
            apiError.status = response.status;
            throw apiError;
        }

        throw new Error("Internal API returned an invalid response");
    }

    if (!response.ok || data?.status !== "OK") {
        console.error(`internalApi error ${path}:`, data);
        const message = data?.error || `Internal API returned HTTP ${response.status}`;
        const apiError = new Error(message);
        apiError.status = response.status;
        apiError.payload = data;
        throw apiError;
    }

    return data.res;
}
